'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export const PopoverTitle = forwardRef(({ children, className, ...restProps }, ref) => {
    return (_jsx("h2", { ...restProps, ref: ref, className: cn('text-body-3 font-medium text-metal-900 dark:text-white', className), children: children }));
});
PopoverTitle.displayName = 'PopoverTitle';
